export default __webpack_public_path__ + "static/media/partner-apeiron.e58ff771.png";